import {Stack, CircularProgress} from "@mui/material";
import {useTranslation} from "react-i18next";

const LoadMore = ({loading, hasMore, onClick, disabled}) => {
  const {t} = useTranslation();

  const _onClick = () => {
    if (disabled) {
      return;
    }
    if (hasMore && onClick) onClick();
  }

  return <Stack direction="row" justifyContent="center" gap={'8px'} alignItems="center" onClick={_onClick}>
    {loading ? <>
      <CircularProgress size={24} sx={theme => {
        return {
          color: !disabled ? theme.palette.text.secondary : theme.palette.brand.main,
        }
      }}/> <span>{t('loading')}</span>
    </> : <span className={`${hasMore ? "cursor-pointer" : ""}`}>
      {hasMore ? t('click_or_scroll_to_load_more') : t('no_more_data')}
    </span>}
  </Stack>;
};

export default LoadMore;